import { render, staticRenderFns } from "./fallback.vue?vue&type=template&id=d3de5f32&scoped=true&"
import script from "./fallback.vue?vue&type=script&lang=ts&"
export * from "./fallback.vue?vue&type=script&lang=ts&"
import style0 from "./fallback.vue?vue&type=style&index=0&id=d3de5f32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3de5f32",
  null
  
)

export default component.exports